module.exports = __webpack_public_path__ + "static/media/plus.2b5a6d0a.svg";